
export default function Industries() {
  const industries = [
    { name: 'Hormone Therapy & BHRT Clinics', icon: 'ri-heart-pulse-line', link: '/industries/hormone-therapy' },
    { name: 'Longevity & Anti-Aging Medicine', icon: 'ri-time-line', link: '/industries/longevity-medicine' },
    { name: 'Functional & Integrative Medicine', icon: 'ri-leaf-line', link: '/industries/functional-medicine' },
    { name: 'Women\'s Health & Menopause', icon: 'ri-women-line', link: '/industries/womens-health' },
    { name: 'Men\'s Health & Wellness', icon: 'ri-user-heart-line', link: '/industries/mens-health' },
    { name: 'Preventive & Internal Medicine', icon: 'ri-shield-cross-line', link: '/industries/preventive-medicine' },
    { name: 'Cardiology & Heart Health', icon: 'ri-heart-line', link: '/industries/cardiology' },
    { name: 'Endocrinology & Metabolic Health', icon: 'ri-test-tube-line', link: '/industries/endocrinology' },
    { name: 'Medical Spas with Hormone Therapy', icon: 'ri-spa-line', link: '/industries/medical-spas' },
    { name: 'Primary Care & Family Medicine', icon: 'ri-stethoscope-line', link: '/industries/primary-care' },
    { name: 'Urology & Men\'s Health', icon: 'ri-capsule-line', link: '/industries/urology' },
    { name: 'Wellness Centers & Clinics', icon: 'ri-hospital-line', link: '/industries/wellness-centers' }
  ];

  return (
    <section id="industries" className="py-24 px-6 lg:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="order-2 lg:order-1">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-4">
                <div className="w-full h-48 rounded-xl overflow-hidden shadow-lg">
                  <img 
                    src="https://public.readdy.ai/ai/img_res/9996e8c7a68696b09f39353583f949ea.jpg"
                    alt="Healthcare professional"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-full h-32 rounded-xl overflow-hidden shadow-lg">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Modern%20medical%20clinic%20interior%20with%20comfortable%20waiting%20area%20clean%20minimalist%20design%20plants%20natural%20light%20welcoming%20healthcare%20environment&width=300&height=200&seq=industry2&orientation=landscape"
                    alt="Modern clinic"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div className="space-y-4 pt-8">
                <div className="w-full h-32 rounded-xl overflow-hidden shadow-lg">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Medical%20team%20meeting%20in%20conference%20room%20discussing%20patient%20care%20strategies%20diverse%20healthcare%20professionals%20collaborative%20environment&width=300&height=200&seq=industry3&orientation=landscape"
                    alt="Medical team"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="w-full h-48 rounded-xl overflow-hidden shadow-lg">
                  <img 
                    src="https://readdy.ai/api/search-image?query=Wellness%20center%20treatment%20room%20with%20modern%20medical%20equipment%20calming%20atmosphere%20soft%20purple%20accent%20lighting%20spa%20like%20medical%20environment&width=300&height=300&seq=industry4&orientation=squarish"
                    alt="Wellness center"
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="order-1 lg:order-2">
            <div className="text-xs uppercase tracking-[0.2em] text-[#7C3AED] font-bold mb-4">
              SPECIALIZED EXPERTISE
            </div>
            <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 leading-tight mb-6">
              Healthcare Providers We Serve
            </h2>
            <p className="text-base text-gray-600 leading-relaxed mb-8">
              We specialize in marketing for hormone therapy, longevity, preventive, and wellness medicine providers. Each industry receives tailored strategies with HIPAA-compliant implementation.
            </p>
            <div className="flex items-center gap-6">
              <div className="text-center">
                <div className="text-3xl font-bold text-[#7C3AED]">200+</div>
                <div className="text-xs text-gray-500">Practices Served</div>
              </div>
              <div className="w-px h-12 bg-gray-200"></div>
              <div className="text-center">
                <div className="text-3xl font-bold text-[#7C3AED]">12+</div>
                <div className="text-xs text-gray-500">Specialties</div>
              </div>
              <div className="w-px h-12 bg-gray-200"></div>
              <div className="text-center">
                <div className="text-3xl font-bold text-[#7C3AED]">98%</div>
                <div className="text-xs text-gray-500">Retention</div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {industries.map((industry, index) => (
            <a
              key={index}
              href={industry.link}
              className="group bg-[#F9FAFB] rounded-xl p-6 hover:bg-gradient-to-r hover:from-[#7C3AED] hover:to-[#A855F7] hover:shadow-xl transition-all duration-300 cursor-pointer border border-gray-100"
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center group-hover:bg-white/20 transition-colors">
                  <i className={`${industry.icon} text-[#7C3AED] text-xl group-hover:text-white transition-colors`}></i>
                </div>
                <div className="flex-1">
                  <h3 className="font-bold text-gray-900 group-hover:text-white transition-colors text-sm">
                    {industry.name}
                  </h3>
                </div>
                <i className="ri-arrow-right-line text-gray-400 group-hover:text-white transition-colors"></i>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-12 text-center">
          <p className="text-sm text-gray-600 mb-6">
            Don't see your specialty? We work with all healthcare and wellness providers.
          </p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 border-2 border-[#7C3AED] text-[#7C3AED] px-8 py-4 rounded-lg hover:bg-[#7C3AED] hover:text-white transition-all cursor-pointer whitespace-nowrap font-medium"
          >
            <span>Discuss Your Practice</span>
            <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}
